/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
export const AgentPromotionJobConfig = core.serialization.object({
    targetEnvironmentId: EnvironmentId,
    spaceId: SpaceId,
});
